import storage from "../../common/storage";

export default {
  //身份类型
  roleType: {
    'teacher': 'teacher', //教师
    'student': 'student', //学生
    'school': 'subjectLeader', //校级
    'district': 'instructor', //区县
    'city': 'cityAdmin', //市级
    'province': 'provinceAdmin', //省级
    'grade': 'grade', //年级
    'class': 'class', //班级
    'proInstructor':'proInstructor',//省教研员
    'cityInstructor':'cityInstructor'//市教研员
  },
  anlysisCard: [{
      code: 'basicLearning',
      name: '基础学习',
      unit: '次',
      imgSrc: 'icon-jichuxuexi'
    },
    {
      code: 'bookSync',
      name: '课本同步',
      unit: '次',
      imgSrc: 'icon-kebentongbu'
    },
    {
      code: 'topicExpr',
      name: '话题表述',
      unit: '次',
      imgSrc: 'icon-huatibiaoshu'
    },
    {
      code: 'classicReading',
      name: '经典欣赏',
      unit: '次',
      imgSrc: 'icon-jingdianxinshang'
    }
  ],
  //身份名称
  roleName: {
    'teacher': '教师', //教师
    'student': '学生', //学生
    'school': '校级管理员', //校级
    'district': '区县管理员', //区县
    'city': '市级管理员', //市级
    'province': '省级管理员', //省级
    'grade': '年级管理员', //年级
    'class': '班级管理员' //班级
  },
  //学生个人报告页面类型
  learnReportType: {
    basicLearning: 'stuBaseLearn',
    bookSync: 'stuTextbookLearn',
    topicExpr: 'stuTopicExpress',
    classicReading: ''
  },
  //音调中文类型
  yinDiaoType: {
    0: "轻声",
    1: "阴平",
    2: "阳平",
    3: "上声",
    4: "下声",
    "ZERO": "零声母"
  },
  statisticType: {
    province:-1,
    city:0,
    district: 1,
    school: 2,
    grade: 3,
    class: 4
  },
  taskType: {
    districtExamination: 3,
    schoolExamination: 2,
    classExamination: 1
  },
  //科目代码
  subjectCode: {
    Chinese: '01'
  },
  singleType: {
    districtSingle: 'districtSingle', //区县单次
    schoolSingle: 'schoolSingle', //学校单次
    gradeSingle: 'gradeSingle', //年级单次
    classSingle: 'classSingle' //班级单次
  },
  moduleType: {
    learnAnalysis: 'learnAnalysis', //学习分析
    examAnalysis: 'examAnalysis', //考试分析
    examManage: 'examManage' //考务管理
  },
  gradeCode: {
    '12': '高三',
    '11': '高二',
    '10': '高一',
    '09': '九年级',
    '08': '八年级',
    '07': '七年级',
    '06': '六年级',
    '05': '五年级',
    '04': '四年级',
    '03': '三年级',
    '02': '二年级',
    '01': '一年级'
  },
  getTaskTypByRole :function()  {
    let roleCode = storage.getSessionStorage("role");
    if(roleCode===this.roleType.teacher){
      return this.taskType.classExamination;
    }if(roleCode===this.roleType.school){
      return this.taskType.schoolExamination;
    }if(roleCode===this.roleType.district){
      return this.taskType.districtExamination;
    }else if(roleCode===this.roleType.city || roleCode===this.roleType.province){
      return this.taskType.districtExamination;
    }else if(roleCode===this.roleType.student) {
    }else{}
  }
}



// WEBPACK FOOTER //
// ./src/js/analysis/anlysisConstants.js